// assets/a24-testimonials.js
(function () {
  'use strict';

  function normalizeEndpoint(endpoint, fallbackPath) {
    // Normalisiert relative und absolute API-Pfade.
    var raw = String(endpoint || '').trim();
    if (!raw) return fallbackPath;
    try {
      var url = new URL(raw, window.location.origin);
      return url.toString();
    } catch (_) {
      return fallbackPath;
    }
  }

  function escapeHtml(value) {
    // Schützt API-Inhalte, bevor sie als Card-HTML gerendert werden.
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncateText(text, maxLength) {
    // Hält lange Rezensionen im Slider kompakt.
    var value = String(text || '').replace(/\s+/g, ' ').trim();
    if (value.length <= maxLength) return value;
    return value.slice(0, maxLength - 1).trim() + '...';
  }

  var hoverTooltipState = {
    element: null,
    contentElement: null,
    activeSource: null
  };

  function ensureHoverTooltip() {
    // Erstellt genau ein globales Tooltip-Element, damit es nie im Slider geclippt wird.
    if (hoverTooltipState.element && hoverTooltipState.contentElement) return hoverTooltipState;
    var tooltip = document.createElement('div');
    tooltip.className = 'a24-floating-tooltip';
    tooltip.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('div');
    inner.className = 'a24-floating-tooltip__inner';
    tooltip.appendChild(inner);

    document.body.appendChild(tooltip);
    hoverTooltipState.element = tooltip;
    hoverTooltipState.contentElement = inner;
    return hoverTooltipState;
  }

  function hideHoverTooltip(source) {
    // Blendet den globalen Tooltip aus (optional nur für eine bestimmte Quelle).
    if (!hoverTooltipState.element) return;
    if (source && hoverTooltipState.activeSource !== source) return;
    hoverTooltipState.element.classList.remove('is-visible');
    hoverTooltipState.element.setAttribute('aria-hidden', 'true');
    hoverTooltipState.activeSource = null;
  }

  function resolveTooltipHorizontalBounds(source, edge) {
    // Ermittelt die erlaubte horizontale Fläche auf Basis der zentrierten Theme-Breite.
    var minLeft = edge;
    var maxRight = window.innerWidth - edge;

    if (source && source.closest) {
      var section = source.closest('.a24-testimonials');
      var inner = section ? section.querySelector('.a24-testimonials__inner') : null;
      if (inner) {
        var innerRect = inner.getBoundingClientRect();
        minLeft = Math.max(edge, Math.round(innerRect.left) + edge);
        maxRight = Math.min(window.innerWidth - edge, Math.round(innerRect.right) - edge);
      }
    }

    if (maxRight <= minLeft) {
      minLeft = edge;
      maxRight = window.innerWidth - edge;
    }

    return {
      minLeft: minLeft,
      maxRight: maxRight
    };
  }

  function positionHoverTooltip(clientX, clientY, source) {
    // Positioniert den Tooltip nahe am Cursor und hält ihn innerhalb Theme-Breite + Viewport.
    if (!hoverTooltipState.element) return;
    var tooltip = hoverTooltipState.element;
    var offset = 14;
    var edge = 12;

    var left = clientX + offset;
    var top = clientY + offset;
    var rect = tooltip.getBoundingClientRect();

    if (left + rect.width > window.innerWidth - edge) {
      left = Math.max(edge, clientX - rect.width - offset);
    }

    var bounds = resolveTooltipHorizontalBounds(source, edge);
    var maxLeft = Math.max(bounds.minLeft, bounds.maxRight - rect.width);
    left = Math.min(Math.max(left, bounds.minLeft), maxLeft);

    if (top + rect.height > window.innerHeight - edge) {
      top = Math.max(edge, clientY - rect.height - offset);
    }

    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
  }

  function showHoverTooltip(source, html, clientX, clientY) {
    // Zeigt den globalen Tooltip mit bereits escaped HTML (inkl. <br>) an.
    if (!html) return;
    var state = ensureHoverTooltip();
    state.contentElement.innerHTML = html;
    state.activeSource = source;
    state.element.classList.add('is-visible');
    state.element.setAttribute('aria-hidden', 'false');
    positionHoverTooltip(clientX, clientY, source);
  }

  function buildHoverTooltipHtml(authorName, starsLabel, starsHtml, textHtml) {
    // Baut den Tooltip-Inhalt inkl. Name + Sterne wie in der Karte.
    var safeName = escapeHtml(authorName || 'A24 Kunde');
    var safeStarsLabel = escapeHtml(starsLabel || '5 von 5 Sternen');
    var safeStarsHtml = starsHtml || renderStars(5);
    var safeTextHtml = textHtml || '';

    return '' +
      '<div class="a24-floating-tooltip__meta">' +
        '<span class="a24-floating-tooltip__name">' + safeName + '</span>' +
        '<div class="a24-floating-tooltip__stars testimonial-card__stars" aria-label="' + safeStarsLabel + '">' + safeStarsHtml + '</div>' +
      '</div>' +
      '<div class="a24-floating-tooltip__text">' + safeTextHtml + '</div>';
  }

  function bindManualHoverTooltips(root) {
    // Bindet verzögerte Hover-Tooltips für gekürzte manuelle Bewertungstexte.
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.testimonial-card__text-wrap--truncated').forEach(function (node) {
      if (node.dataset.a24TooltipBound === 'true') return;
      var source = node.querySelector('.testimonial-card__tooltip-inner');
      if (!source) return;

      var card = node.closest('.testimonial-card');
      var nameNode = card ? card.querySelector('.testimonial-card__name') : null;
      var starsNode = card ? card.querySelector('.testimonial-card__stars') : null;
      var tooltipHtml = buildHoverTooltipHtml(
        nameNode ? nameNode.textContent.trim() : 'A24 Kunde',
        starsNode ? starsNode.getAttribute('aria-label') : '5 von 5 Sternen',
        starsNode ? starsNode.innerHTML : renderStars(5),
        source.innerHTML
      );

      node.dataset.a24TooltipBound = 'true';

      var timerId;
      var lastX = 0;
      var lastY = 0;

      function clearTimer() {
        if (!timerId) return;
        clearTimeout(timerId);
        timerId = null;
      }

      function startTimer() {
        clearTimer();
        timerId = setTimeout(function () {
          showHoverTooltip(node, tooltipHtml, lastX, lastY);
          timerId = null;
        }, 1500);
      }

      node.addEventListener('mouseenter', function (event) {
        lastX = event.clientX;
        lastY = event.clientY;
        startTimer();
      });

      node.addEventListener('mousemove', function (event) {
        lastX = event.clientX;
        lastY = event.clientY;
        if (hoverTooltipState.activeSource === node) {
          positionHoverTooltip(lastX, lastY, node);
        }
      });

      node.addEventListener('mouseleave', function () {
        clearTimer();
        hideHoverTooltip(node);
      });

      node.addEventListener('mousedown', function () {
        clearTimer();
        hideHoverTooltip(node);
      });
    });
  }

  function renderStars(stars) {
    // Rendert feste Kartensterne für einzelne Bewertungen.
    var safeStars = Math.max(1, Math.min(parseInt(stars, 10) || 5, 5));
    var html = '';
    var i;
    for (i = 0; i < safeStars; i += 1) html += '<span aria-hidden="true">★</span>';
    for (i = safeStars; i < 5; i += 1) html += '<span class="testimonial-card__star--empty" aria-hidden="true">★</span>';
    return html;
  }

  function renderRatingStars(avgRating) {
    // Rendert die Sterne in der Google-Zusammenfassung.
    var rounded = Math.max(0, Math.min(Math.round(Number(avgRating) || 0), 5));
    var stars = '';
    var i;
    for (i = 0; i < rounded; i += 1) stars += '★';
    for (i = rounded; i < 5; i += 1) stars += '☆';
    return stars;
  }

  function buildCardHtml(review, fallbackUrl) {
    // Baut eine einzelne API-Bewertung als Card und hält alle Strings escaped.
    var author = escapeHtml(review.author || 'Google Nutzer');
    var text = escapeHtml(truncateText(review.text, 220));
    var dateRelative = escapeHtml(review.date_relative || '');
    var dateApprox = escapeHtml(review.date_approx || '');
    var stars = Math.max(1, Math.min(parseInt(review.stars, 10) || 5, 5));
    var avatarUrl = String(review.avatar_url || '').trim();
    var reviewUrl = escapeHtml(review.review_url || review.url || fallbackUrl || '');
    var authorFirstLetter = escapeHtml(((review.author || 'G').trim().charAt(0) || 'G').toUpperCase());
    var avatarHtml = avatarUrl
      ? '<img class="testimonial-card__avatar" src="' + escapeHtml(avatarUrl) + '" alt="' + author + '" width="44" height="44" loading="lazy">'
      : '<div class="testimonial-card__avatar testimonial-card__avatar--letter">' + authorFirstLetter + '</div>';

    return '' +
      '<article class="testimonial-card" data-api-review' + (reviewUrl ? ' data-review-url="' + reviewUrl + '" role="link" tabindex="0" aria-label="Bewertung auf Google öffnen"' : '') + '>' +
        '<div class="testimonial-card__top">' +
          '<div class="testimonial-card__author-wrap">' +
            avatarHtml +
            '<div class="testimonial-card__author-info">' +
              '<span class="testimonial-card__name">' + author + '</span>' +
              (dateRelative ? '<time class="testimonial-card__date" datetime="' + dateApprox + '">' + dateRelative + '</time>' : '') +
            '</div>' +
          '</div>' +
          '<svg class="testimonial-card__google-icon" viewBox="0 0 488 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" fill="#4285F4"/>' +
          '</svg>' +
        '</div>' +
        '<div class="testimonial-card__stars" aria-label="' + stars + ' von 5 Sternen">' + renderStars(stars) + '</div>' +
        '<p class="testimonial-card__text">' + text + '</p>' +
      '</article>';
  }

  function initTestimonials(root) {
    // Initialisiert eine Testimonials-Section mit API-, Manual- oder Kombimodus.
    if (!root || root.dataset.a24TestimonialsReady === 'true') return;
    root.dataset.a24TestimonialsReady = 'true';

    var cfg = window.A24 || {};
    var sourceMode = root.getAttribute('data-source-mode') || 'api_with_manual';
    var apiLimit = Math.max(1, Math.min(parseInt(root.getAttribute('data-api-limit'), 10) || 5, 12));
    var usesApi = sourceMode === 'api' || sourceMode === 'api_with_manual';
    var usesManual = sourceMode === 'manual' || sourceMode === 'api_with_manual';
    var track = root.querySelector('.testimonials__track');
    var dotsEl = root.querySelector('.testimonials__dots');
    var statusEl = root.querySelector('.testimonials__status');
    var prevBtn = root.querySelector('.testimonials__arrow--prev');
    var nextBtn = root.querySelector('.testimonials__arrow--next');
    var badgeEl = root.querySelector('[data-google-badge]');
    var scoreEl = root.querySelector('.testimonials__google-score');
    var starsEl = root.querySelector('.testimonials__google-stars');
    var countEl = root.querySelector('.testimonials__google-count');
    var labelEl = root.querySelector('.testimonials__google-label');
    var scrollTimer;
    var resizeTimer;

    if (!track) return;

    var manualHtml = usesManual ? track.innerHTML : '';
    if (!usesManual) track.innerHTML = '';

    function resolveReviewsEndpoint() {
      // Leitet aus dem Search-Endpoint den Google-Reviews-Endpoint ab.
      var searchEndpoint = normalizeEndpoint(cfg.apiBaseUrl || cfg.searchEndpoint || '/api/search-suggest-v2', '/api/search-suggest-v2');
      try {
        var url = new URL(searchEndpoint, window.location.origin);
        url.pathname = url.pathname.replace(/\/search-suggest(?:-v2)?\/?$/i, '/google-reviews');
        if (!/\/google-reviews\/?$/i.test(url.pathname)) {
          url.pathname = '/api/google-reviews';
        }
        url.search = 'limit=' + apiLimit;
        url.hash = '';
        return url.toString();
      } catch (_) {
        return '/api/google-reviews?limit=' + apiLimit;
      }
    }

    function setStatus(message, isError) {
      // Statuszeile anzeigen, ohne Layoutfläche zu blockieren.
      if (!statusEl) return;
      statusEl.textContent = message;
      statusEl.style.display = message ? '' : 'none';
      statusEl.style.color = isError ? '#b91c1c' : '';
    }

    function getCards() {
      // Liefert alle aktuell sichtbaren Karten, egal ob API oder manuell.
      return Array.prototype.slice.call(track.querySelectorAll('.testimonial-card'));
    }

    function rebuildDots(count) {
      // Baut die Sliderpunkte passend zur aktuellen Kartenanzahl neu auf.
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      for (var i = 0; i < count; i += 1) {
        var dot = document.createElement('button');
        dot.className = 'testimonials__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Bewertung ' + (i + 1));
        dotsEl.appendChild(dot);
      }
    }

    function gap() {
      // Liest den echten CSS-Gap, damit Scroll-Schritte auch responsive stimmen.
      var computed = window.getComputedStyle(track);
      var g = parseInt(computed.columnGap || computed.gap, 10);
      return Number.isNaN(g) ? 20 : g;
    }

    function step() {
      // Breite eines Slider-Schritts aus realem Kartenabstand ableiten.
      var cards = getCards();
      if (!cards.length) return 0;
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return cards[0].getBoundingClientRect().width + gap();
    }

    function visible() {
      // Anzahl gleichzeitig sichtbarer Karten.
      var cardStep = step();
      if (!cardStep) return 1;
      return Math.max(1, Math.floor((track.clientWidth + gap()) / cardStep));
    }

    function curIdx() {
      // Aktuelle Sliderposition anhand von scrollLeft berechnen.
      var cards = getCards();
      var cardStep = step();
      if (!cardStep) return 0;
      var max = Math.max(0, cards.length - visible());
      return Math.min(max, Math.max(0, Math.round(track.scrollLeft / cardStep)));
    }

    function pageCount() {
      // Anzahl möglicher Sliderpositionen.
      var cards = getCards();
      return Math.max(1, cards.length - visible() + 1);
    }

    function syncUi() {
      // Synchronisiert Dots und Pfeile nach Scroll, Resize oder DOM-Wechsel.
      var dots = dotsEl ? Array.prototype.slice.call(dotsEl.querySelectorAll('.testimonials__dot')) : [];
      var idx = curIdx();
      var pages = pageCount();

      dots.forEach(function (dot, i) {
        dot.hidden = i >= pages;
        dot.classList.toggle('is-active', i === idx);
      });

      if (prevBtn) {
        prevBtn.disabled = idx <= 0;
        prevBtn.classList.toggle('is-disabled', prevBtn.disabled);
      }
      if (nextBtn) {
        nextBtn.disabled = idx >= (pages - 1);
        nextBtn.classList.toggle('is-disabled', nextBtn.disabled);
      }
    }

    function goTo(index) {
      // Scrollt zu einer Sliderposition.
      var cardStep = step();
      if (!cardStep) return;
      var cards = getCards();
      var max = Math.max(0, cards.length - visible());
      var next = Math.min(Math.max(index, 0), max);
      track.scrollTo({ left: next * cardStep, behavior: 'smooth' });
    }

    function bindDots() {
      // Dots nach jedem Neuaufbau klickbar machen.
      if (!dotsEl) return;
      Array.prototype.slice.call(dotsEl.querySelectorAll('.testimonials__dot')).forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });
    }

    function bindOpenInNewTab(node, url) {
      // Bewertungen und Badge öffnen externe URLs per Maus und Tastatur.
      if (!node || !url || node.dataset.a24ReviewBound === 'true') return;
      node.dataset.a24ReviewBound = 'true';
      node.addEventListener('click', function (event) {
        if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
        window.open(url, '_blank', 'noopener,noreferrer');
      });
      node.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
          event.preventDefault();
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      });
    }

    function bindReviewLinks() {
      // Alle Karten mit data-review-url werden als externe Links behandelt.
      root.querySelectorAll('[data-review-url]').forEach(function (node) {
        bindOpenInNewTab(node, node.getAttribute('data-review-url'));
      });
    }

    function refreshSlider(message, isError) {
      // Gemeinsamer Refresh nach API-Erfolg, API-Fehler oder Manual-Fallback.
      var count = getCards().length;
      rebuildDots(count);
      bindDots();
      bindReviewLinks();
      bindManualHoverTooltips(root);
      syncUi();
      if (count > 0) {
        setStatus(message || '', isError);
      } else {
        setStatus(message || 'Keine Bewertungen verfügbar.', true);
      }
    }

    function updateBadgeLink(url) {
      // Macht die Google-Zusammenfassung klickbar, wenn die API eine URL liefert.
      if (!badgeEl || !url) return;
      badgeEl.style.cursor = 'pointer';
      badgeEl.setAttribute('data-review-url', url);
      badgeEl.setAttribute('role', 'link');
      badgeEl.setAttribute('tabindex', '0');
      badgeEl.setAttribute('aria-label', 'Google Bewertungen im neuen Fenster öffnen');
      bindOpenInNewTab(badgeEl, url);
    }

    function replaceTrackWithManual(message, isError) {
      // Stellt den manuellen Zustand wieder her, etwa bei API-Ausfall.
      track.innerHTML = manualHtml;
      refreshSlider(message, isError);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(curIdx() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(curIdx() + 1); });

    track.addEventListener('scroll', function () {
      hideHoverTooltip();
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncUi, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      hideHoverTooltip();
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncUi, 100);
    });

    if (!usesApi) {
      replaceTrackWithManual('', false);
      return;
    }

    fetch(resolveReviewsEndpoint(), { credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Reviews API nicht erreichbar');
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !Array.isArray(payload.reviews) || payload.reviews.length === 0) {
          throw new Error('Keine Bewertungen verfügbar');
        }

        var reviews = payload.reviews.slice(0, apiLimit);
        var apiHtml = reviews.map(function (review) {
          return buildCardHtml(review, payload.reviewsUrl);
        }).join('');
        track.innerHTML = sourceMode === 'api_with_manual' && manualHtml.trim()
          ? apiHtml + manualHtml
          : apiHtml;

        if (badgeEl && payload.reviewsUrl) updateBadgeLink(payload.reviewsUrl);
        refreshSlider('', false);

        if (scoreEl) scoreEl.textContent = (Number(payload.averageRating || 0)).toFixed(1).replace('.', ',');
        if (starsEl) {
          starsEl.textContent = renderRatingStars(payload.averageRating);
          starsEl.setAttribute('aria-label', (Number(payload.averageRating || 0)).toFixed(1).replace('.', ',') + ' von 5 Sternen');
        }
        if (labelEl && payload.placeName) labelEl.textContent = 'Google Bewertungen - ' + payload.placeName;
        if (countEl) {
          if (payload.summary) {
            countEl.textContent = payload.summary + ' | Durchschnitt ' + (Number(payload.averageRating || 0)).toFixed(2).replace('.', ',') + ' bei ' + Number(payload.totalRatings || 0) + ' Bewertungen';
          } else {
            countEl.textContent = 'Durchschnitt ' + (Number(payload.averageRating || 0)).toFixed(2).replace('.', ',') + ' bei ' + Number(payload.totalRatings || 0) + ' Bewertungen';
          }
        }
      })
      .catch(function () {
        if (sourceMode === 'api_with_manual' && manualHtml.trim()) {
          replaceTrackWithManual('Automatische Bewertungen konnten nicht geladen werden. Manuelle Bewertungen werden angezeigt.', true);
          return;
        }

        setStatus('Bewertungen konnten nicht geladen werden. Bitte später erneut versuchen.', true);
        track.innerHTML = '';
        if (dotsEl) dotsEl.innerHTML = '';
      });
  }

  function initAll(scope) {
    // Initialisiert alle Testimonials im aktuellen Dokument oder Section-Reload.
    var rootScope = scope || document;
    if (rootScope.matches && rootScope.matches('[data-a24-testimonials]')) initTestimonials(rootScope);
    if (rootScope.querySelectorAll) {
      rootScope.querySelectorAll('[data-a24-testimonials]').forEach(initTestimonials);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.requestAnimationFrame(function () { initAll(document); });
    }, { once: true });
  } else {
    window.requestAnimationFrame(function () { initAll(document); });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
